import { lock } from './lock-unlock';
import { useRichText, getDomPositionKey } from './hook';
import { useFormatTypes } from './hook/use-format-types';
import { KeyboardShortcutContext, InputEventContext } from './contexts';
import { RichTextShortcut } from './keyboard-shortcut';
import { RichTextInputEvent } from './input-event';
import { shortcutsListener, inputEventsListener } from './event-listeners';
import { ownsSelection } from './owns-selection';
import { subscribeOwnedListener } from './subscribe-owned-listener';

/**
 * Private `@wordpress/rich-text` APIs.
 */
export const privateApis = {};
lock( privateApis, {
	useRichText,
	getDomPositionKey,
	useFormatTypes,
	KeyboardShortcutContext,
	InputEventContext,
	RichTextShortcut,
	RichTextInputEvent,
	shortcutsListener,
	inputEventsListener,
	ownsSelection,
	subscribeOwnedListener,
} );
